import * as React from "react";

import { assertNever } from "@impero-com/common/utils/obj";

import {
    HalfYear,
    SchedulingOccurrenceChangeForDueDateOffsetForMonthOffsetPeriod as SchedulingOccurrenceChange,
} from "api/generated/model";
import { translateHalfYear } from "org/control/list/utils";

import { GenericCustomDueDatesModal } from "../common/genericCustomDueDatesDialog";
import { GenericOccurrencesArray } from "../common/rulesWithArrays";
import { CustomDueDatesTypedProps } from "../types";

const ALL_OCCURRENCES: HalfYear[] = ["First", "Second"];

type HalfYearlyCustomDueDatesModalProps = CustomDueDatesTypedProps<HalfYear> & {
    initialCurrentOccurrences: GenericOccurrencesArray<HalfYear>;
};

class HalfYearlyCustomDueDatesModal extends React.Component<HalfYearlyCustomDueDatesModalProps> {
    onChange = (
        currentOccurrences: Partial<
            Record<HalfYear, SchedulingOccurrenceChange>
        >
    ) => {
        if (this.props.type !== "EDIT") {
            throw new Error("not editable");
        }
        const { onChange } = this.props;
        ALL_OCCURRENCES.forEach((occurrence) => {
            const change = currentOccurrences[occurrence];
            if (change !== undefined) {
                onChange(occurrence, change);
            }
        });
    };

    render = () => {
        const { type, initialCurrentOccurrences } = this.props;

        let typedProps;
        switch (type) {
            case "EDIT": {
                typedProps = {
                    type: "EDIT" as const,
                    onChange: this.onChange,
                };
                break;
            }
            case "READ_ONLY": {
                typedProps = {
                    type: "READ_ONLY" as const,
                };
                break;
            }
            default: {
                return assertNever(type);
            }
        }

        return (
            <GenericCustomDueDatesModal<HalfYear>
                {...typedProps}
                initialCurrentOccurrences={initialCurrentOccurrences}
                allOccurrences={ALL_OCCURRENCES}
                translateOccurrence={translateHalfYear}
                translateOccurrenceShort={translateHalfYear}
                interval={"HalfYear"}
            />
        );
    };
}

export { HalfYearlyCustomDueDatesModal };
